import { Component, OnInit } from '@angular/core';
import { PrimitiveType } from '../../../../class/workflow.type';

import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

/**
 * Building block to display readonly information
 */
@CoreBuildingBlock('alert')
@Component({
  selector: 'cu-alert',
  templateUrl: './alert.component.html',
  standalone: false
})
export class AlertFieldComponent extends CoreBuildingBlockControlBaseComponent implements OnInit {
  /** Type of alert - info, success,warning,error */
  public alertType: PrimitiveType = 'info';
  public get message(): string {
    return this.parse(this.field.config.subLabel);
  }

  /** types of alert */
  private readonly types = { info: 'info', success: 'success', warning: 'warning', error: 'error' };
  public ngOnInit(): void {
    this.alertType = this.field.config.defaultValue ? this.getAlertType(this.field.config.defaultValue.toString()) : this.types.info;
  }

  /**
   * Determines the alert type based on the provided value
   * @param value - The value to determine the alert type from
   * @returns The alert type as a string
   */
  private getAlertType(value: string): string {
    switch (value.toLowerCase()) {
      case this.types.success:
        return this.types.success;
      case this.types.warning:
        return this.types.warning;
      case this.types.error:
        return this.types.error;
      case this.types.info:
        return this.types.info;
      default:
        return this.types.info;
    }
  }

  /**
   * Determines if the close icon should be shown
   * @returns boolean indicating whether to show the close icon
   */
  public get showCloseIcon(): boolean {
    return this.field.payload && this.field.payload.showCloseIcon ? (this.field.payload.showCloseIcon as boolean) : false;
  }
}
